import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatasourceDownstreamWorkbooksWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatasourceDownstreamWorkbooksWithoutPersonalSpaceQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
